import { COUNTRIES } from '../data/countries';

// El país se guarda de dos formas según dónde se haya capturado:
//  - Registro -> código ISO ("MX")
//  - Edición de perfil (Settings) -> nombre en español ("México")
// Estos helpers normalizan ambos casos usando el catálogo oficial de `data/countries`.

const ISO_A_NOMBRE: Record<string, string> = {};
const NOMBRE_A_ISO: Record<string, string> = {};

const norm = (s: string): string =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();

COUNTRIES.forEach((c) => {
  ISO_A_NOMBRE[c.value.toUpperCase()] = c.label;
  NOMBRE_A_ISO[norm(c.label)] = c.value.toUpperCase();
});

const esIso = (v: string): boolean => /^[A-Za-z]{2}$/.test(v.trim());

/** Devuelve el código ISO alfa-2 del país, venga como código o como nombre. */
export const isoPais = (valor?: string): string => {
  if (!valor) return '';
  const v = valor.trim();
  if (esIso(v)) return v.toUpperCase();
  return NOMBRE_A_ISO[norm(v)] || '';
};

/** Devuelve el nombre en español del país, venga como código ISO o como nombre. */
export const nombrePais = (valor?: string): string => {
  if (!valor) return '';
  const v = valor.trim();
  if (esIso(v)) return ISO_A_NOMBRE[v.toUpperCase()] || v.toUpperCase();
  return v;
};

/** Devuelve la bandera emoji del país, o '' si no se reconoce. */
export const banderaPais = (valor?: string): string => {
  const iso = isoPais(valor);
  if (!iso) return '';
  return iso.replace(/./g, (c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65));
};
